class JustificativaDomain {
      id: Number = 0;
      descricao: string = "";
      categoria: string = "";
      d_E_L_E_T_E: boolean = false;
      criadoEm: Date = new Date();
      excluidoEm: Date = new Date();
}
export default JustificativaDomain;